// extracted by mini-css-extract-plugin
export default {"buttonWrapper":"FilterButton_buttonWrapper__rMbuA","tagActive":"FilterButton_tagActive__7HilX","tagIcon":"FilterButton_tagIcon__XtIv9"};